import { render, staticRenderFns } from "./likedArchives.vue?vue&type=template&id=2d987741&scoped=true"
import script from "./likedArchives.vue?vue&type=script&lang=js"
export * from "./likedArchives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d987741",
  null
  
)

export default component.exports